"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactPose = _interopRequireWildcard(require("react-pose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Content = (0, _styledComponents.default)(_reactPose.default.div({
  enter: {
    y: 0,
    opacity: 1,
    delay: 300,
    transition: {
      y: ({
        stiffness,
        damping
      }) => ({
        type: 'spring',
        stiffness,
        damping
      }),
      default: {
        duration: 300
      }
    }
  },
  exit: {
    y: p => p.delta ? -p.delta : -50,
    opacity: 0,
    transition: {
      duration: 150
    }
  }
})).attrs(p => ({
  width: p.width || 640,
  height: p.height ? `${p.height}px` : 'auto',
  top: p.top || 160,
  left: p.left,
  right: p.right,
  zIndex: p.zIndex || 1
})).withConfig({
  displayName: "Modal__Content",
  componentId: "wpvboi-0"
})(["display:flex;flex-direction:column;position:absolute;", ";background:#fff;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,0.5);"], p => `
    z-index: ${p.zIndex};
    width: ${p.width}px;
    height: ${p.height};
    top: ${p.top}px;
    ${p.right ? `right: ${p.right}px` : ''};
    ${p.left ? `left: ${p.left}px` : ''};
    ${!p.right && !p.left ? `left: calc(50% - ${p.width / 2}px)` : ''};
    max-height: calc(100vh - ${p.top}px - 16px);
  `);
const Shade = (0, _styledComponents.default)(_reactPose.default.div({
  enter: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
})).attrs(p => ({
  zIndex: p.zIndex || 1
})).withConfig({
  displayName: "Modal__Shade",
  componentId: "wpvboi-1"
})(["position:fixed;", ";top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.2);"], p => `
    z-index: ${p.zIndex};
  `);

class Modal extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      show: false
    });

    _defineProperty(this, "closeStart", () => {
      this.setState({
        show: false
      });
    });

    _defineProperty(this, "closeComplete", () => {
      const {
        onShow,
        onClose
      } = this.props;
      const {
        show
      } = this.state;

      if (show) {
        onShow();
      } else {
        onClose();
      }
    });
  }

  componentDidMount() {
    const {
      show
    } = this.props;
    this.setState({
      show
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      show
    } = this.props;

    if (show !== prevProps.show) {
      this.setState({
        show
      });
    }
  }

  render() {
    const {
      delta,
      width,
      height,
      top,
      right,
      left,
      zIndex,
      stiffness = 250,
      damping = 18,
      attachToBody,
      children
    } = this.props;
    const {
      show
    } = this.state;

    const el = /*#__PURE__*/_react.default.createElement(_reactPose.PoseGroup, null, show && [/*#__PURE__*/_react.default.createElement(Shade, {
      key: "shade",
      zIndex: zIndex,
      onClick: this.closeStart
    }), /*#__PURE__*/_react.default.createElement(Content, {
      key: "content",
      delta: delta,
      width: width,
      height: height,
      top: top,
      right: right,
      left: left,
      zIndex: zIndex,
      stiffness: stiffness,
      damping: damping,
      onPoseComplete: this.closeComplete
    }, children)]);

    if (attachToBody) {
      return /*#__PURE__*/_reactDom.default.createPortal(el, document.body);
    }

    return el;
  }

}

Modal.defaultProps = {
  onShow: () => {},
  onClose: () => {}
};
var _default = Modal;
exports.default = _default;